import React from 'react'
import { Container } from '../../components/templates/Wrappers'

export const StyleguidePage: React.FC = () => {

    return (
        <Container>
            <h1 className="space">STYLEGUIDE </h1>
            <a href="https://github.com/Statsministeriet/styleguide">GitHub</a>
            <h2 className="space">Colors</h2>
            <h3>Primary</h3>

            <h2 className="space">Typography</h2>
            <h1>Heading H1 - Aa Bb Cc Dd</h1>
            <div className="highlight">Heading 1 - 48px/1.291em</div>
            <h2>Heading h2 - Aa Bb Cc Dd</h2>
            <div className="highlight">Heading 2 - 38px/1.368em</div>
            <h3>Heading H3 - Aa Bb Cc Dd</h3>
            <div className="highlight">Heading 3 - 24px/1.416em</div>
            <h4>Heading H4 - Aa Bb Cc Dd</h4>
            <div className="highlight">Heading 4 - 22px/1.545em</div>
            <h5>Heading H5 - Aa Bb Cc Dd</h5>
            <div className="highlight">Heading 5 - 18px/1.555em - weight: 400</div>
            <h6>Heading H6 - Aa Bb Cc Dd</h6>
            <div className="highlight">Heading 6 - 16px/1.625em - weight: 400</div>

            <p className="small space">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.
                Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean
                faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.
            </p>
            <div className="highlight">Paragraph small - 13px/1.3em</div>


            <p className="space">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.
                Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean
                faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.
            </p>
            <div className="highlight">Paragraph Default - 16px/1.687em</div>

            <p className="large space">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.
                Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean
                faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.
            </p>
            <div className="highlight">Paragraph Large - 20px/1.7em</div>

            <blockquote className="space">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquet euismod ut id ullamcorper
                nunc diam.
                Amet a ac ut pharetra. Amet, accumsan, nisl in elementum volutpat integer. Cursus est elementum maecenas ut.
            </blockquote>
            <div className="highlight">Block Quote</div>

            <p className="space"><strong>Bold - Lorem ipsum dolor sit amet</strong></p>
            <div className="highlight">Bold Text</div>

            <p className="space"><strong>Bold - Lorem ipsum dolor sit amet</strong></p>
            <div className="highlight">Bold Text</div>

            <a href="#">Link - Lorem ipsum dolor sit amet</a>
            <div className="highlight">Link Text</div>


            <ul role="list">
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</li>
                <li>Platea dictumst vestibulum rhoncus est pellentesque. Malesuada</li>
                <li>Risus at ultrices mi tempus imperdiet nulla malesuada</li>
            </ul>
            <div className="highlight">Bullet List</div>

            <ol role="list">
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</li>
                <li>Platea dictumst vestibulum rhoncus est pellentesque. Malesuada</li>
                <li>Risus at ultrices mi tempus imperdiet nulla malesuada</li>
            </ol>
            <div className="highlight">Numbered List</div>

            <h2 className="space">Buttons</h2>
            <button className="small">Small</button>
            <div className="highlight">Small button</div>

            <button>Default</button>
            <div className="highlight">Default button</div>

            <button className="large">Large</button>
            <div className="highlight">Large button</div>

            <h2 className="space">Forms</h2>

            <input placeholder="Placeholder" className="small" />
            <div className="highlight">Input small</div>

            <input placeholder="Placeholder" />
            <div className="highlight">Input default</div>


            <div className="space"></div>
        </Container>

    )

}

